import { DistanceUnit, ShapeType, ShapeComp } from "Store/firebase/mapObjects/Components/@ShapeComp";
import { Clone, CloneWithPrototypes } from "js-vextensions";
import { MapObject } from "Store/firebase/mapObjects/@MapObject";
export class ShapeDrawer {
    InitContext(props) {
        this.Extend(props);
    }
    InitToolProps(props) {
        this.Extend(props);
    }
    get MinLineLength_Meters() {
        return this.mapScene.ConvertDistanceUnit(this.minLineLengthUnit, DistanceUnit.Meters, this.minLineLength);
    }
    CreateNewShape(baseShape, firstMousePos_canvas) {
        const { width, height } = this.mapScene.props;
        const downPos_world = this.mapScene.MousePos_World(firstMousePos_canvas);
        const downPos_fromObjPos = downPos_world.Minus(this.objPosition);
        const newShape = Clone(baseShape).As(ShapeComp);
        newShape.InitShape(downPos_fromObjPos);
        this.shape = newShape;
    }
    GetUpdatedNewShape(nextMousePos_canvas) {
        const { width, height } = this.mapScene.props;
        var currentPos_world = this.mapScene.MousePos_World(nextMousePos_canvas);
        const currentPos_fromObjPos = currentPos_world.Minus(this.objPosition);
        const newShape = CloneWithPrototypes(this.shape);
        if (newShape.type == ShapeType.Rectangle) {
            newShape.rect.VSet({ width: currentPos_fromObjPos.x, height: currentPos_fromObjPos.y });
        }
        else if (newShape.type == ShapeType.Region || newShape.type == ShapeType.Path) {
            const distFromLastPoint = currentPos_fromObjPos.DistanceTo(this.shape.pathPoints.Last());
            if (distFromLastPoint >= this.MinLineLength_Meters) {
                newShape.pathPoints.push(currentPos_fromObjPos);
            }
        }
        return newShape;
    }
    UpdateNewShape(nextMousePos_canvas) {
        this.shape = this.GetUpdatedNewShape(nextMousePos_canvas);
    }
    ShapeAsObject() {
        return new MapObject({ position: this.objPosition, shape: this.shape });
    }
}
